import { Stack, Typography, TypographyProps } from "@mui/material";
import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { useTranslation } from "react-i18next";

export type TableCellProviderStatusProps = {
  data: {
    nbViews?: number;
    nbTotalViews?: number;
    value?: boolean;
    transcoding: boolean;
  };
};

const TableCellProviderStatus: React.FC<TableCellProviderStatusProps> = (props) => {
  const { t } = useTranslation();
  const value = props.data.value;
  let color: TypographyProps["color"];
  let text = "";
  let icon;

  if (!props.data.transcoding) {
    switch (value) {
      case false:
        color = "error.main";
        icon = <CancelOutlinedIcon color="error" fontSize="small" />;
        text = t("common:expired");
        break;
      default:
        color = "primary.main";
        icon = <CheckIcon color="primary" fontSize="small" />;
        text = t("common:active");
        break;
    }
  } else {
    color = "warning.main";
    icon = <HourglassEmptyIcon color="warning" fontSize="small" />;
    text = t("common:transcoding");
  }

  return (
    <Stack color={color} spacing={0.5}>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {icon}
        <Typography fontWeight={500} sx={{ color: color }}>
          {text}
        </Typography>
      </Stack>

      <Typography color="text.tier" variant="body2">
        {props.data.nbViews + "/" + (props.data.nbTotalViews ?? t("common:unlimited"))}
      </Typography>
    </Stack>
  );
};

export default TableCellProviderStatus;
